"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _dsWeb = require("@olxbr/ds-web");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var AdvertisingPlaceholder = function AdvertisingPlaceholder(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    adOnLoad = _useState2[0],
    setAdOnLoad = _useState2[1];
  (0, _react.useEffect)(function () {
    window.googletag = window.googletag || {
      cmd: []
    };
    var _window = window,
      googletag = _window.googletag;
    var changeSlotBackgroundColor = function changeSlotBackgroundColor(event) {
      var _event$slot;
      var eventSlotId = event === null || event === void 0 || (_event$slot = event.slot) === null || _event$slot === void 0 ? void 0 : _event$slot.getSlotElementId();
      if (!eventSlotId || eventSlotId !== _constants.ADVERTISING_SLOT) return;
      setAdOnLoad(true);
      googletag === null || googletag === void 0 || googletag.cmd.push(function () {
        return googletag.pubads().removeEventListener('slotOnload', changeSlotBackgroundColor);
      });
    };
    googletag === null || googletag === void 0 || googletag.cmd.push(function () {
      return googletag.pubads().addEventListener('slotOnload', changeSlotBackgroundColor);
    });
    return function () {
      googletag === null || googletag === void 0 || googletag.cmd.push(function () {
        return googletag.pubads().removeEventListener('slotOnload', changeSlotBackgroundColor);
      });
    };
  }, [_constants.ADVERTISING_SLOT]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
    "data-testid": "advertising-placeholder",
    justifyContent: "center",
    alignItems: "center",
    style: {
      width: '970px',
      height: '90px',
      overflow: 'hidden',
      margin: 'var(--spacing-3) 0 var(--spacing-3) 0',
      backgroundColor: adOnLoad ? 'var(--color-neutral-80)' : 'var(--color-neutral-90)',
      opacity: adOnLoad ? 1 : 0.5
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.BodySmall, {
      tag: "p",
      color: adOnLoad ? '--color-neutral-100' : '--color-neutral-120',
      style: {
        position: 'absolute'
      },
      children: _constants.ADVERTISING_PLACEHOLDER_TEXT
    }), children]
  });
};
var _default = exports["default"] = AdvertisingPlaceholder;